<script setup lang="ts">
import { RouterLink } from 'vue-router';
</script>

<template>
  <main class="error-page">
    <h1>Page not found</h1>
    <p>The page you were looking for doesn't exist.</p>
    <RouterLink to="/">Return to sign-in</RouterLink>
  </main>
</template>

<style scoped>
.error-page {
  max-width: 32rem;
  margin: 6rem auto;
  padding: 2rem;
  text-align: center;
}
</style>
